import type { Event, EventHint } from '@sentry/react';

const RECAPTCHA_TIMEOUT = /^(reCAPTCHA )?Timeout$/;

const isRecaptchaTimeout = (exception: unknown): boolean => {
  const message = exception instanceof Error ? exception.message : exception;
  return typeof message === 'string' && RECAPTCHA_TIMEOUT.test(message);
};

// Filter out reCAPTCHA-related timeout errors.
// These occur when Microsoft's email scanners visit password reset URLs
// and Google's reCAPTCHA times out on those IP addresses.
// See https://github.com/getsentry/sentry-javascript/issues/2514
const beforeSend = (event: Event, hint: EventHint): Event | null => {
  if (isRecaptchaTimeout(hint.originalException)) return null;
  return event;
};

export default beforeSend;
